import { PerformanceDatapoint } from './PerformanceDatapoint';
import type { DatapointOptions } from 'owa-analytics-types';
import type { AnalyticsCoreEventNames, AnalyticsEventNames } from 'owa-analytics-events';
import type { MailboxInfo } from 'owa-client-types';

export default class VerboseDatapoint extends PerformanceDatapoint {
    constructor(
        eventName: AnalyticsEventNames | AnalyticsCoreEventNames,
        mailbox: MailboxInfo | undefined,
        options?: DatapointOptions
    ) {
        const verboseDatapointOptions: DatapointOptions = { ...(options ? options : {}) };

        verboseDatapointOptions.isVerbose = true;

        super(eventName, mailbox, verboseDatapointOptions);
    }
}
